import React from "react";
import { MockupSlot } from "./MockupSlot";
import { OfferLink } from "./OfferLink";
import { productVisuals } from "../data/offer";
export function Hero() {
  return <section id="top" className="bg-cream" data-id="element-88" data-mp="9ktchjcqjuvn">
      <div className="mx-auto grid max-w-6xl items-center gap-10 px-5 pb-16 pt-10 md:pb-24 md:pt-16 lg:grid-cols-[1.05fr_1fr] lg:gap-16" data-id="element-89" data-mp="9lv00naxu9u9">
        <div data-id="element-90" data-mp="4jm6npu5l5rm">
          <p className="text-xs font-extrabold tracking-[0.2em] text-sage-deep" data-id="element-91" data-mp="129h2fs8fj8fj">
            PETITES HISTOIRES, GRANDE FOI
          </p>
          <p className="mt-3 font-display text-lg font-semibold uppercase leading-snug text-azure md:text-xl" data-id="element-92" data-mp="xbfkxbqnjh66">
            Le Méga Pack de Paraboles Chrétiennes
          </p>

          <div className="mt-5 inline-flex items-center gap-4 rounded-2xl bg-blush-light py-3 pl-4 pr-5" data-id="element-93" data-mp="ncgjad4b0lso">
            <div className="flex flex-col items-center leading-none" data-id="element-94" data-mp="3d21t5zvq8oos">
              <span className="text-[10px] font-extrabold tracking-widest text-terracotta" data-id="element-95" data-mp="3cz5weevm861x">
                PLUS DE
              </span>
              <span className="font-display text-4xl font-bold text-terracotta" data-id="element-96" data-mp="3j897ze322dq2">
                50
              </span>
            </div>
            <div className="h-10 w-px bg-terracotta/25" aria-hidden="true" data-id="element-97" data-mp="3o6u6n92nspce" />
            <p className="text-xs font-extrabold leading-snug tracking-wide text-ink md:text-sm" data-id="element-98" data-mp="399jm7a81g94j">
              PARABOLES ILLUSTRÉES
              <br data-id="element-99" data-mp="3ebiqqnfilc32" />+ ACTIVITÉS BIBLIQUES
            </p>
          </div>

          <h1 className="mt-6 font-display text-[2.1rem] font-semibold leading-[1.12] text-ink md:text-5xl md:leading-[1.08]" data-id="element-100" data-mp="30ggdff8c8kg8">
            Transmettez votre foi à vos enfants et créez de précieux moments en
            famille autour de la Parole de Dieu.
          </h1>
          <p className="mt-5 max-w-xl text-base leading-relaxed text-ink-soft md:text-lg" data-id="element-101" data-mp="2vi54d6pvadz2">
            Des histoires touchantes, des versets bibliques et des activités à
            imprimer pour apprendre, échanger et grandir ensemble dans la foi.
          </p>

          <div className="mt-8 flex flex-col items-start gap-3" data-id="element-102" data-mp="2lml98mj4njbd">
            <OfferLink className="w-full sm:w-auto" data-id="element-103" data-mp="s3mavvwi5mv7">DÉCOUVRIR LE MÉGA PACK</OfferLink>
            <p className="text-xs font-semibold text-ink-soft md:text-sm" data-id="element-104" data-mp="najfrjc2u5cw">
              Format numérique à imprimer • Paiement unique • Garantie 7 jours
            </p>
          </div>
        </div>

        <MockupSlot src={productVisuals.heroMockup} label="Mockup du Méga Pack" className="aspect-square w-full lg:aspect-[4/5]" data-id="element-105" data-mp="degf6hwvies2" />
      </div>
    </section>;
}